<template lang="html">
  <chart :chartData="chartData" :options="options" v-if="chartData !== undefined"></chart>
  <spinner v-else></spinner>
</template>

<script>
import Chart from '@/pages/statistics/components/graphiques/BarChart.vue'
import Spinner from '@/components/common/spinner.vue'
import * as R from 'ramda'
import {statusLabel} from '@/helpers/labels'

export default {
  props: ['showAmountNotNumber'],
  data () {
    return {
      chartData: undefined,
      options: undefined
    }
  },
  components: {
    'chart': Chart,
    'spinner': Spinner
  },
  created () {
    // this.$engine.monitoring.initAllGraphs()
    this.options = {responsive: true}
  },
  mounted () {
    if (this.$engine.monitoring.graphByStatus !== undefined) {
      this.chartData = this.makeChartData(this.$engine.monitoring.graphByStatus)
    }
  },
  watch: {
    '$engine.monitoring.graphByStatus': {
      handler (val) {
        if (val === undefined) {
          this.chartData = undefined
        } else {
          this.chartData = this.makeChartData(this.$engine.monitoring.graphByStatus)
        }
      },
      deep: true
    },
    showAmountNotNumber: {
      handler () {
        if (this.$engine.monitoring.graphByStatus !== undefined) {
          this.chartData = this.makeChartData(this.$engine.monitoring.graphByStatus)
        }
      }
    }
  },
  methods: {
    makeChartData (rawData) {
      const label = status => statusLabel(this.$i18n, status)
      let data = {
        labels: R.map(label, R.keys(rawData.creditor)),
        datasets: []
      }
      let dataCred = {data: [], label: '', backgroundColor: [], borderColor: []}
      let dataDeb = {data: [], label: '', backgroundColor: [], borderColor: []}
      for (let status in rawData.creditor) {
        dataCred.label = 'Received'
        if (this.showAmountNotNumber) {
          dataCred.data = R.append(rawData.creditor[status].amount, dataCred.data)
        } else {
          dataCred.data = R.append(rawData.creditor[status].number, dataCred.data)
        }

        dataCred.backgroundColor = [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
          'rgba(255, 159, 64, 0.8)',
          'rgba(255, 179, 20, 0.8)'
        ]
        dataCred.borderColor = [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
          'rgba(255, 159, 64, 0.8)',
          'rgba(255, 179, 20, 0.8)'
        ]
      }
      for (let status in rawData.debtor) {
        dataDeb.label = 'Sent'
        if (this.showAmountNotNumber) {
          dataDeb.data = R.append(rawData.debtor[status].amount, dataDeb.data)
        } else {
          dataDeb.data = R.append(rawData.debtor[status].number, dataDeb.data)
        }
        dataDeb.backgroundColor = [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
          'rgba(255, 159, 64, 0.8)',
          'rgba(255, 179, 20, 0.8)'
        ]
        dataDeb.borderColor = [
          'rgba(255, 99, 132, 0.8)',
          'rgba(54, 162, 235, 0.8)',
          'rgba(255, 206, 86, 0.8)',
          'rgba(75, 192, 192, 0.8)',
          'rgba(153, 102, 255, 0.8)',
          'rgba(255, 159, 64, 0.8)',
          'rgba(255, 179, 20, 0.8)'
        ]
      }
      data.datasets = [dataCred, dataDeb]
      return data
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// GraphByStatus.vue?4f94573c